import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { CameleonHero } from '../components/sections/secteurs/CameleonHero';
import { SectorsGrid } from '../components/sections/secteurs/SectorsGrid';
import { AssimilationProcess } from '../components/sections/secteurs/AssimilationProcess';
import { SecteursCTA } from '../components/sections/secteurs/SecteursCTA';

export default function SecteursPage() {
  return (
    <div data-testid="secteurs-page" className="min-h-screen bg-[#020209]">
      <Navbar />
      <main>
        <CameleonHero />
        <SectorsGrid />
        <AssimilationProcess />
        <SecteursCTA />
      </main>
      <Footer />
    </div>
  );
}
